/* eslint-disable no-unused-vars */
import Vue from 'vue';
import Vuex from 'vuex';
import config from '../../appConfig';
import { getURLParameterVal } from './helpers';
import { getBoxOffset } from '../utils/threejsUtils'
import { checkIsModelTrasnlated } from '../utils/forgeUtils'
import { ForgeViewerService } from './../scripts/js/forgeService';
import { ForgeSettings, UserSettings } from './../scripts/js/forgeModels';
import { dispose2DViewer, getViewPage2d, launchPlanViewer, getMessagePopup } from './../scripts/js/forgeviewer';
import HttpService from '@/utils/httpService';
import { MEASUREMENT } from './modules/measurement';
import { TAGS } from './modules/tags';
import { MARKUPS } from './modules/markups';
import { ModelBrowser } from './modules/modelBrowser';
import { GlobalSearch } from './modules/globalSearch';
import { Attachments } from './modules/attachments';
import { Viewers } from './modules/viewers';
import { timeline } from './modules/timeline';
import { InspectionDashboard } from './modules/inspection-dashboard';
import { SharedDashboardSettings } from './modules/shared-dashboard-settings';
import { SisTestingDashboard } from './modules/sis-testing-dashboard';
import { WorkPackProgressDashboard } from './modules/work-pack-progress-dashboard';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        forgeService: new ForgeViewerService(),        
        markupsComponent: null,
        markupsApp: null,
        currentUrn: null,
        currentApp: null,
        pdfViewerLoaded: false,
        viewerMouseDownEvent: null,
        mouseDownHitTest: null,
        adminAppContainer: null,
        markupImageHeight: 8,
        markupImageWidth: 8,

        debugMode: config.debugMode,
        assetId: getURLParameterVal('assetId'),
        assetName: getURLParameterVal('assetName', true),
        contractName: getURLParameterVal('contractName', true),
        clientName: getURLParameterVal('clientName', true),
        userId: getURLParameterVal('userId'),
        defaultViewType: getURLParameterVal('view'),
        username: getURLParameterVal('username', true),
        email: getURLParameterVal('email', true),
        parentSiteUrl: getURLParameterVal('url', true),
        parentSiteName: getURLParameterVal('type'),
        pointCloudContainer: getURLParameterVal('pcAzureContainerURL', true),
        isMarkupImage: getURLParameterVal('isMarkupImage') == 1,
        showActivityManagerBtn: getURLParameterVal('showAM') == 1 ? true : false,
        isAdminUser: getURLParameterVal('isAdmin') == 1 ? true : false,
        parentModuleUrl: getURLParameterVal('moduleUrl') ? getURLParameterVal('moduleUrl', true) : '',
        testPackageId: getURLParameterVal('referenceContextId'),
        testPackageNumber: getURLParameterVal('testPackageNumber', false),
        parentAPI: getURLParameterVal('parentApi', true) ?? "",
        parentBlob: getURLParameterVal('parentBlob', true),
        currentInputElement: null,
        virtualKeyboardShown: false,
        dataFetched: false,
        isLargeModel: false,
        shareFileToken: null,
        isGeometryLoaded: false,
        isTreeLoaded: false,
        dbidsToLoad: null,
        cropBoxApplied: false,
        pinnedPoint2d: null,
        pinnedPoint3d: null,
        pinnedPoint360: null,
        isPickingTag: false,
        isPickingSubTag: false,
        isPickingCropOrigin: false,
        isDrawingAreaToDownloadPC: false,
        isPickingPin: false,
        forgeSettings: new ForgeSettings(),
        userSettings: new UserSettings(),
        categories: [],
        showAddAutoTagsPopup: false,
        showCreateInspectionPopup: false,
        tagsToCreateInspection: [],
        selectedDbids: [],
        tags: [],
        addRemove3dModeEnabled: false,
        isEmptyModel: false,
        globalOffset: 0,
        unitScale: 0,

        //ghosting
        isGhostingOn: false,
        isGhostingWireframe: true,
        ghostingOpacity: 100,
        ghostingColor: '#cad3db',
        isGreyModel: false,

        selectedTab: -1,
        isTabShown: false,

        //global search
        filteredTags: [],
        filteredPipelines: [],
        filteredStructural: [],
        filtered360Imgs: [],
        filteredCameras: [],
        filteredModels: [],
        filteredPointClouds: [],
        filteredAnnotations: [],
        filteredInspections: [],
        filteredScaffolds: [],
        filteredPermits: [],
        filteredContainers: [],
        // This value is only used internally to update the components that contains the tags.
        // Because changing the tags [] not reflect on those components well.
        // It would help if you used it as a variable in your function that needs to be updated.
        updateComponentUsingTags: '',

        selectedImage: null,
        selectedLevel: null,
        displayUnit: null,
        areViewsLocked: false,
        _360ThumbnailInfo: { shown: false, imgUrl: '', item: null, x: 0, y: 0 },
        _3dThumbnailInfo: { shown: false, imgUrl: '', item: null, x: 0, y: 0 },
        _2dThumbnailInfo: { shown: false, imgUrl: '', item: null, x: 0, y: 0 },
        isRealityActivityManagerShown: false,
        isRealityDashboardShown: false,
        showComparasionTool: false,
        showCroppingBoxPopup: false,
        showBottomButtons: true,
        showLeftButtons: true,
        isIsolating3D: false,
        annotations: [],
        inspections: [],
        scaffolds: [],
        projects: [],
        levels: [],
        pointClouds: [],
        cameras: [],
        uploadedModels: [],
        shareFileItems: [],
        //point clouds download
        pointCloudDownloads: [],
        shownPointCloudDownloadInfo: null,
        shareFilePopupInfo: { id: '', shown: false },
        editingPointCloudDownloadInfo: null,

        activityManagerViewIndex: 0,

        lastOpenTabIndex: null,
        lastGlobalSearchSelectedItem: null,
        lastSelectedTagId: "",
        transformMode: "scale",
        showLoading: false,

        activeVideoSrc: null,

        // popups
        successfulMessage: "",
        showAddProperty: false,
        addPropertyCallback: null,
        showCropLevelPopup: false,
        showPointCloudDisplayPopup: false,
        showSelectDashboardPopup: false,

        // 360 viewer
        tooltipObject: null,

        //viewers
        viewer: null,
        planUrn: null,
        planViewer: null,
        mainUrn: null,
        selectedModel: null,
        pdfviewer: null,
        camera3dPosition: null,
        load2dViewerCallback: null,
        load360ViewerCallback: null,
        ignoreModelSelectionEvent: false,

        fetchedState: null,

        onSelectionChangedCallback: null,

        // ModelBrowser
        isolatedNodes: [],

        //point clouds download 
        downloadBoxOffset: 0,
        imagesInCropbox: [],
        isPointCloudDownloadEditing: false,

        activityStatusColor: null,

        // LocalStorage keys
        localStoragePreferencesKeys: {
            doNotShowAgainIsolateLocalStorage: 'DoNotShowAgainIsolate'
        }
    },
    getters: {
        getAssetId(state) {
            return state.assetId;
        },
        getIsLargeModel(state) {
            return state.isLargeModel;
        },
        getIsIsolating3D(state) {
            return state.isIsolating3D
        },
        getInspections(state) {
            return state.inspections;
        },
        getShowCroppingBoxPopup(state) {
            return state.showCroppingBoxPopup;
        },
        getShowBottomButtons(state) {
            return state.showBottomButtons;
        },
        getShowLeftButtons(state) {
            return state.showLeftButtons;
        },
        get360ThumbnailPopupInfo(state) {
            return state._360ThumbnailInfo;
        },
        get3dThumbnailPopupInfo(state) {
            return state._3dThumbnailInfo;
        },
        get2dThumbnailPopupInfo(state) {
            return state._2dThumbnailInfo;
        },
        getIsRealityActivityManagerShown(state) {
            return state.isRealityActivityManagerShown;
        },
        getIsRealityDashoardShown(state) {
            return state.isRealityDashboardShown;
        },
        getSuccessMessage(state) {
            return state.successfulMessage;
        },
        getActiveVideoSrc(state) {
            return state.activeVideoSrc;
        },
        getDisplayUnit(state) {
            return state.displayUnit;
        },
        getShowActivityManagerBtn(state) {
            return state.showActivityManagerBtn
        },
        getShowCropLevelPopup(state) {
            return state.showCropLevelPopup;
        },
        getAllTags(state) {
            return state.tags
                .concat(state.annotations)
                .concat(state.inspections)
                .concat(state.scaffolds)
                .concat(store.getters.GET_MANUAL_PIPELINES_TAGS)
                .concat(store.getters.GET_MANUAL_STRUCTURAL_TAGS)
                .concat(store.getters.GET_AMIS_TAGS)
                .concat(store.getters.GET_AUTOMATIC_TAGS)
                .concat(store.getters.GET_STRUCTURAL_TAGS)
                .concat(store.getters.GET_PIPELINES_TAGS);
        },
        GET_ALL_EXISTING_TAGS(state) {
            return state.tags
                .concat(state.annotations)
                .concat(state.inspections)
                .concat(state.scaffolds)
                .concat(store.getters.GET_MANUAL_PIPELINES_TAGS)
                .concat(store.getters.GET_MANUAL_STRUCTURAL_TAGS)
                .concat(store.getters.GET_ALL_AMIS_TAGS_IDS)
                .concat(store.getters.GET_ALL_EXISTING_AUTOMATIC_TAGS)
                .concat(store.getters.GET_ALL_EXISTING_STRUCTURAL_TAGS)
                .concat(store.getters.GET_ALL_EXISTING_PIPELINES_TAGS);
        },
        getShowAddProperty(state) {
            return state.showAddProperty
        },
        getAddPropertyCallback(state) {
            return state.addPropertyCallback;
        },
        getLastOpenTabIndex(state) {
            return state.lastOpenTabIndex;
        },
        getLastGlobalSearchSelectedItem(state) {
            return state.lastGlobalSearchSelectedItem;
        },
        getIsolatedNodes(state) {
            return state.isolatedNodes;
        },
        getShowComparasionTool(state) {
            return state.showComparasionTool
        },
        getTooltipObject(state) {
            return state.tooltipObject;
        },
        getSelectedModel(state) {
            return state.selectedModel;
        },
        getCamera3dPosition(state) {
            return state.camera3dPosition;
        },
        getLastSelectedTagId(state) {
            return state.lastSelectedTagId;
        },
        getPointCloudDownloads(state) {
            return state.pointCloudDownloads;
        },
        getImagesInCropbox(state) {
            return state.imagesInCropbox
        },
        getDownloadBoxOffset(state) {
            return state.downloadBoxOffset
        },
        getPointClouds(state) {
            return state.pointClouds;
        },
        getIsPointCloudDownloadEditing(state) {
            return state.isPointCloudDownloadEditing
        },
        getIsDrawingAreaToDownloadPC(state) {
            return state.isDrawingAreaToDownloadPC;
        },
        getLevels(state) {
            return state.levels;
        },
        getProjects(state) {
            return state.projects;
        },
        getParentSiteName(state) {
            return state.parentSiteName;
        },
        getIsFlutterRunning(state) {
            return !!state.parentSiteName && state.parentSiteName.toLowerCase().includes('flutter');
        },
        getIsAdminUser(state) {
            // return !!state.email && state.email.includes('@modsmanagement.com');
            return state.isAdminUser;
        },
        getTransformMode(state) {
            return state.transformMode;
        },
        getShowLoading(state) {
            return state.showLoading;
        },
        getParentModuleUrl(state) {
            return state.parentModuleUrl;
        },
        getIsTreeLoaded(state) {
            return state.isTreeLoaded
        },
        getTestPackageId(state) {
            return state.testPackageId;
        },
        getTestPackageNumber(state) {
            return state.testPackageNumber;
        },
        getIgnoreModelSelectionEvent(state) {
            return state.ignoreModelSelectionEvent;
        },
        getSelectedDbids(state) {
            return state.selectedDbids;
        },
        GET_IS_EMPTY_MODEL(state) {
            return state.isEmptyModel;
        },
        GET_SHOW_SELECT_DASHBOARD_POPUP(state) {
            return state.showSelectDashboardPopup;
        },
        getLoad360ViewerCallback(state) {
            return state.load360ViewerCallback;
        },
        GET_MAIN_URN(state) {
            return state.mainUrn;
        },
        GET_ON_SELECTION_CHANGED_CALLBACK(state) {
            return state.onSelectionChangedCallback;
        }
    },
    mutations: {
        setAssetId(state, value) {
            state.assetId = value;
        },
        setIsLargeModel(state, value) {
            state.isLargeModel = value;
        },
        setParentSiteName(state, value) {
            state.parentSiteName = value;
        },
        setIsPickingTag(state, value) {
            state.isPickingTag = value;
            state.isPickingSubTag = false;
            state.isPickingCropOrigin = false;
            state.isPickingPin = false;
        },
        setIsPickingSubTag(state, value) {
            state.isPickingTag = false;
            state.isPickingSubTag = value;
            state.isPickingCropOrigin = false;
        },
        setIsPickingCropOrigin(state, value) {
            state.isPickingTag = false;
            state.isPickingSubTag = false;
            state.isPickingCropOrigin = value;
        },
        setIsPickingPin(state, value) {
            state.isPickingPin = value;
        },
        setIsTabShown(state, value) {
            state.isTabShown = value;
        },
        setSelectedTab(state, value) {
            state.selectedTab = value;
        },
        setIsIsolating3D(state, value) {
            state.isIsolating3D = value;
        },
        setShowCroppingBoxPopup(state, value) {
            state.showCroppingBoxPopup = value;
        },
        setShowBottomButtons(state, value) {
            state.showBottomButtons = value;
        },
        setShowLeftButtons(state, value) {
            state.showLeftButtons = value;
        },
        setSuccessMessage(state, value) {
            state.successfulMessage = value;
        },
        setActiveVideoSrc(state, value) {
            state.activeVideoSrc = value
        },
        setThumnailPopupInfo(state, info) {
            if (info.type == '3d')
                state._3dThumbnailInfo = info.info;
            else if (info.type == '2d')
                state._2dThumbnailInfo = info.info;
            else if (info.type == '360')
                state._360ThumbnailInfo = info.info;
        },
        hideThumbnailPopup(state, type) {
            if (type == '3d')
                state._3dThumbnailInfo.shown = false;
            else if (type == '2d')
                state._2dThumbnailInfo.shown = false;
            else if (type == '360')
                state._360ThumbnailInfo.shown = false;
            else {
                state._3dThumbnailInfo.shown = false;
                state._2dThumbnailInfo.shown = false;
                state._360ThumbnailInfo.shown = false;
            }
        },
        setIsRealityActivityManagerShown(state, value) {
            state.isRealityActivityManagerShown = value;
        },
        setIsRealityDashoardShown(state, value) {
            state.isRealityDashboardShown = value;
        },
        setDisplayUnit(state, unit) {
            state.displayUnit = unit;
        },
        setShowCropLevelPopup(state, value) {
            state.showCropLevelPopup = value;
        },
        setTags(state, value) {
            state.tags = value;
        },
        setProjects(state, value) {
            state.projects = value;
        },
        setLevels(state, value) {
            state.levels = value;
        },
        setPointClouds(state, value) {
            state.pointClouds = value;
        },
        setPointCloudDownloads(state, value) {
            state.pointCloudDownloads = value;
        },
        setAnnotations(state, value) {
            state.annotations = value;
        },
        setInspections(state, value) {
            state.inspections = value;
        },
        setScaffolds(state, value) {
            state.scaffolds = value;
        },
        setShowAddProperty(state, value) {
            state.showAddProperty = value;
        },
        setAddPropertyCallback(state, value) {
            state.addPropertyCallback = value;
        },
        setLastOpenTabIndex(state, value) {
            state.lastOpenTabIndex = value;
        },
        setLastGlobalSearchSelectedItem(state, value) {
            state.lastGlobalSearchSelectedItem = value;
        },
        setIsolatedNodes(state, value) {
            state.isolatedNodes = value;
        },
        setShowComparasionTool(state, value) {
            state.showComparasionTool = value;
        },
        setTooltipObject(state, value) {
            state.tooltipObject = value;
        },
        setSelectedModel(state, value) {
            state.selectedModel = value;
        },
        setCamera3dPosition(state, value) {
            state.camera3dPosition = value;
        },
        setLastSelectedTagId(state, value) {
            state.lastSelectedTagId = value;
        },
        setImagesInCropbox(state, value) {
            state.imagesInCropbox = value;
        },
        setDownloadBoxOffset(state, value) {
            state.downloadBoxOffset = value;
        },
        setIsPointCloudDownloadEditing(state, value) {
            state.isPointCloudDownloadEditing = value;
        },
        setIsDrawingAreaToDownloadPC(state, value) {
            state.isDrawingAreaToDownloadPC = value;
        },
        setTransformMode(state, value) {
            state.transformMode = value;
        },
        setShowLoading(state, value) {
            state.showLoading = value;
        },
        setIsTreeLoaded(state, value) {
            state.isTreeLoaded = value;
        },
        setLoad2dViewerCallback(state, value) {
            state.load2dViewerCallback = value;
        },
        setLoad360ViewerCallback(state, value) {
            state.load360ViewerCallback = value;
        },
        setIgnoreModelSelectionEvent(state, value) {
            state.ignoreModelSelectionEvent = value;
        },
        setSelectedDbids(state, value) {
            state.selectedDbids = value;
        },
        SET_IS_EMPTY_MODEL(state, value) {
            state.isEmptyModel = value;
        },
        SET_SHOW_SELECT_DASHBOARD_POPUP(state, value) {
            state.showSelectDashboardPopup = value;
        },
        SET_ON_SELECTION_CHANGED_CALLBACK(state, value) {
            state.onSelectionChangedCallback = value;
        }
    },
    actions: {
        GET_DATA_FROM_LOCAL_STORAGE({ state, commit }) {
            let encodedKey1 = btoa('inspectionPropertiesWithCheck');
            let v1 = localStorage.getItem(encodedKey1);
            if (v1) {
                commit('SET_INSPECTION_PROPERTIES_WITH_CHECK', JSON.parse(v1))
            }
        },
        SET_VIEWER_DISPLAY_DEFAULT_PREFERENCES({ state, commit }) {
            
            let settingsPanel = state.viewer.getSettingsPanel();

            if (!settingsPanel) return;

            let preferences = settingsPanel.preferences;

            if (preferences) {

                preferences.set('lightPreset', 4);
            }

            const defaultCallbackValue = { detail: { target: { checked: true } } };

            settingsPanel.controls[settingsPanel.antialiasingChkBoxId]?.listeners?.change[0]?.callbackFn(defaultCallbackValue)
            settingsPanel.controls[settingsPanel.ambientshadowsChkBoxId]?.listeners?.change[0]?.callbackFn(defaultCallbackValue)
            settingsPanel.controls[settingsPanel.groundShadowChkBoxId]?.listeners?.change[0]?.callbackFn(defaultCallbackValue)
            settingsPanel.controls[settingsPanel.groundReflectionChkBoxId]?.listeners?.change[0]?.callbackFn(defaultCallbackValue)
        },
        closeLeftTab({ commit, state }) {
            state.isTabShown = false;

            if (state.selectedTab == 0) {
                state.forgeService.update3dIconsInAllViews()
            }
        },
        clearThumbnailPopup(state, type) {
            if (type == '3d')
                state._3dThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
            else if (type == '2d')
                state._2dThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
            else if (type == '360')
                state._360ThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
            else {
                state._3dThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
                state._2dThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
                state._360ThumbnailInfo = { shown: false, imgUrl: '', item: null, x: 0, y: 0 };
            }
        },
        updateImagesInCropbox({ commit, state }) {
            let cropping3DExtension = state.forgeService.getCropping3DExtension();
            let offset = parseFloat(state.downloadBoxOffset) / state.viewer.model.getUnitScale()

            let newBox = getBoxOffset(cropping3DExtension.cropBox, offset)
            var imagesInBox = state.forgeService.getAllPanoramaImages().filter(o => newBox.containsPoint(o.getCameraPositionInViewer()));
            commit('setImagesInCropbox', imagesInBox)
            cropping3DExtension.drawOffsetCropBox();
            state.viewer.impl.invalidate(false, false, true);
        },
        updateDisplayUnit({ commit, state }, { displayUnit }) {
            let data = { 'assetId': state.assetId, 'displayUnit': displayUnit };
            HttpService.post({
                url: `api/forge/models/updateDisplayUnit`,
                data: data,
            }).then(() => {
                state.displayUnit = displayUnit;
            }).catch(error => {
                console.log(error);
            });
        },
        showLevel({ dispatch, commit, state }, { level }) {
            dispose2DViewer();
            state.levels.forEach(o => o.isSelected = false);
            level.isSelected = true;

            if (!level.planUrn) {
                dispatch({ type: "alert_Forge", message: 'Plot plan is not yet uploaded, please upload the plot plan first.' })
                return;
            }

            state.selectedLevel = level;
            if (!getViewPage2d()) {
                store.state.mainApp.openViewPageWithType('2d');
            } else {
                store.state.mainApp.showViewPageWithType('2d');
            }
            setTimeout(() => {
                launchPlanViewer(level.planUrn);
            }, 100);
            checkIsModelTrasnlated(level.planUrn, (isTranslated, progress) => {
                if (!isTranslated) {
                    if (progress) {
                        dispatch({
                            type: "alert_Forge",
                            message: 'Plot plan translating is in-progress, please give it more time to finish translating.'
                        })
                    } else {
                        dispatch({
                            type: "alert_Forge",
                            message: 'Plot plan is not yet uploaded, please upload the plot plan first.'
                        })
                    }
                }
            });
        },
        removeImageFromProjects({ dispatch, commit, state }, { image }) {
            var targetProject = state.projects.find(o => o.images.includes(image));
            var index = targetProject.images.findIndex(o => o == image);
            targetProject.images.splice(index, 1);
        },
        toggleAreaToDownloadPC({ dispatch, commit, state }, { value }) {
            commit('setImagesInCropbox', []);
            commit("setIsDrawingAreaToDownloadPC", value)
            commit('setIsPointCloudDownloadEditing', value);

            if (!value) {
                store.state.forgeService.getDrawPointsExtension()?.toggleMeasuringArea(false);
                store.state.forgeService.getMeasureExtensionInViewer2D()?.deactivate();
            }
        },
        clearEditTagTab({ dispatch, commit, state }) {
            commit('setIsPickingTag', false);
            commit('SET_EDITING_TAG', null);
            commit("SET_IS_TAG_READ_ONLY", true)
        },

        clearEditAMISTagTab({ dispatch, commit, state }) {
            commit('setIsPickingTag', false);
            commit('SET_EDITING_AMIS_TAG', null);
            commit("SET_IS_AMIS_TAG_READ_ONLY", true)
        },
        // Tags
        addEquipmentTag({ dispatch, commit, state }, { tag }) {
            state.tags.push(tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;
        },
        updateEquipmentTag({ dispatch, commit, state }, { tag }) {
            store.state.forgeService.updateAllLinkedTagsWithTagLinks(tag)
            var parentList = tag.tagHarvesterId ? state.TAGS.automaticTags : state.tags;
            var index = parentList.findIndex(o => o.id == tag.id);

            if (index == -1) return false;

            parentList.splice(index, 1, tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },
        // Pipelines
        updatePipeline({ dispatch, commit, getters, state }, { tag }) {
            store.state.forgeService.updateAllLinkedTagsWithTagLinks(tag);

            let parentList = tag.tagHarvesterId ? state.TAGS.pipelinesTags : getters.GET_MANUAL_PIPELINES_TAGS;

            var index = parentList.findIndex(o => o.id == tag.id);

            if (index == -1) return false;

            parentList.splice(index, 1, tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },
        // Structural
        updateStructural({ dispatch, commit, getters, state }, { tag }) {
            store.state.forgeService.updateAllLinkedTagsWithTagLinks(tag);

            let parentList = tag.tagHarvesterId ? state.TAGS.structuralTags : getters.GET_MANUAL_STRUCTURAL_TAGS;

            var index = parentList.findIndex(o => o.id == tag.id);

            if (index == -1) return false;

            parentList.splice(index, 1, tag);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },
        // Annotations
        updateAnnotation({ dispatch, commit, state }, { annotation }) {
            store.state.forgeService.updateAllLinkedTagsWithTagLinks(annotation)

            var index = state.annotations.findIndex(o => o.id == annotation.id);

            if (index == -1) return false;

            state.annotations.splice(index, 1, annotation);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },
        // Inspections
        updateInspections({ dispatch, commit, state }, { inspection }) {
            store.state.forgeService.updateAllLinkedTagsWithTagLinks(inspection)

            var index = state.inspections.findIndex(o => o.id == inspection.id);

            if (index == -1) return false;

            state.inspections.splice(index, 1, inspection);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            store.state.forgeService.updateAMISTagsColors([inspection]);

            dispatch('UPDATE_AVAILABLE_FILTERS_COLORS', () => {
                let ids = state.TAGS.selectedColorOptions.map(t => t.id);
                state.TAGS.selectedColorOptions = [...store.state.TAGS.InspectionAvailableColorOptions.filter(i => ids.includes(i.id))];
            });

            return true;
        },
        // Scaffolds
        updateScaffolds({ dispatch, commit, state }, { scaffold }) {

            store.state.forgeService.updateAllLinkedTagsWithTagLinks(scaffold)
            var index = state.scaffolds.findIndex(o => o.id == scaffold.id);

            if (index == -1) return false;

            state.scaffolds.splice(index, 1, scaffold);

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },
        updateAMISTag({ dispatch, commit, state }, { tag }) {
            // forgeService.updateAllLinkedTagsWithTagLinks(tag)

            var index = state.TAGS.amisTags.findIndex(o => o.id == tag.id);

            if (index == -1) return false;

            store.state.forgeService.updateAMISTagsColors([tag]);

            state.TAGS.amisTags.splice(index, 1, tag);

            let t = state.TAGS.allAMISFilteredInspections.find(t => t.id == tag.id);

            if (t == null) {
                state.TAGS.allAMISFilteredInspections.push(tag);
            } else {
                t.point = tag.point;
            }

            state.updateComponentUsingTags = !state.updateComponentUsingTags;

            return true;
        },

        updateTransformMode({ dispatch, commit, state }, { mode }) {
            commit("setTransformMode", mode);

            if (store.state.viewer) {
                store.state.forgeService.updateScaffoldin3D();
            }
        },

        ///
        zoomToPointIn2D({ dispatch, commit, state }, { point3d, levelName, callback, shouldZoom = false }) {
            // Get level containing the point.
            let level = state.levels.find(o => o.name == levelName) || store.state.forgeService.getLevelContainsPoint(point3d);

            // In case no level contains this point but there is a selected level use this level.
            if (state.selectedLevel &&
                state.selectedLevel.mappingViewersPointsInfo &&
                state.selectedLevel != level &&
                state.selectedLevel.mappingViewersPointsInfo.isReady() &&
                state.selectedLevel.containsElevation(point3d.z)) {
                level = state.selectedLevel;
            }

            // Show error if the level have no urn.
            if (!level || !level.planUrn) {
                dispatch({
                    type: "alert_Forge",
                    message: 'No Level found for the selected item.'
                })
                return;
            }

            // Show error if the level is not mapped.
            if (!state.selectedLevel.mappingViewersPointsInfo || !state.selectedLevel.mappingViewersPointsInfo.isReady()) {
                dispatch({
                    type: "alert_Forge",
                    message: 'Level not mapped, please map level first in admin page.'
                })
                return;
            }

            if (level != state.selectedLevel) {
                // Set the selected level to the level.
                state.selectedLevel = level;

                if (shouldZoom) store.state.forgeService.pointToZoomToIn2d = point3d;

                // Open 2d viewer if not opened yet.
                if (state.planViewer) {
                    store.state.mainApp.showViewPageWithType('2d');
                    launchPlanViewer(level.planUrn);
                } else {
                    store.state.mainApp.openViewPageWithType('2d');
                }

                if (callback) commit('setLoad2dViewerCallback', callback);
            } else {
                if (state.planViewer) {
                    store.state.mainApp.showViewPageWithType('2d');
                    if (shouldZoom) store.state.forgeService.zoomToPoint2D(point3d);
                    if (callback) callback();
                } else {
                    if (shouldZoom) store.state.forgeService.pointToZoomToIn2d = point3d;
                    store.state.mainApp.openViewPageWithType('2d');
                    if (callback) commit('setLoad2dViewerCallback', callback);
                }
            }
        },
        showSuccessfulMessage({ commit, state }, { message, timeout }) {
            state.successfulMessage = message;

            if (timeout) {
                setTimeout(() => {
                    state.successfulMessage = '';
                }, timeout)
            }
        },

        ///
        alert_Forge(_, { message }) {
            getMessagePopup().show({
                title: "Warning!",
                text: message,
                isAlert: true,
            });
        },
        prompt_Forge(_, { title, callback, input = {
            inputName: "",
            inputValue: ""
        } }) {
            getMessagePopup().show({
                title: title,
                isConfirm: false,
                isAlert: false,
                callback: callback,
                input: input
            });
        },
        prompt_Forge_Extended(_, { title, callback,
            input = {
                inputName: "",
                inputValue: ""
            },
            extendedInput = {
                inputName: "",
                inputValue: ""
            }
        }) {
            getMessagePopup().showExtendedInput({
                title: title,
                isConfirm: false,
                isAlert: false,
                callback: callback,
                input: input,
                extendedInput: extendedInput
            });
        },
        confirm_Forge(_, { message, askShowAgain, cancelCallback, callback }) {
            getMessagePopup().show({
                text: message,
                isConfirm: true,
                askShowAgain: !!askShowAgain,
                callback: callback,
                cancelCallback: cancelCallback
            });
        },

    },
    modules: {
        MEASUREMENT: MEASUREMENT,
        TAGS: TAGS,
        MARKUPS: MARKUPS,
        ModelBrowser: ModelBrowser,
        GlobalSearch: GlobalSearch,
        Attachments: Attachments,
        Viewers: Viewers,
        timeline: timeline,
        SharedDashboardSettings: SharedDashboardSettings,
        InspectionDashboard: InspectionDashboard,
        SisTestingDashboard: SisTestingDashboard,
        WorkPackProgressDashboard: WorkPackProgressDashboard,
    },
});

// For debugging.
window.vuexStore = store;

// Local 
if (config.debugMode && !store.state.parentAPI) {
    store.state.parentAPI = 'https://reality.mods.solutions/api/'
    store.state.parentAPI = 'https://localhost:44359/'
}

export default store;